import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { usePortal } from '../contexts/PortalContext';
import { brand } from '../data/projects';
import { Projects } from './portal/Projects';
import { ProjectAdmin } from './portal/ProjectAdmin';
import { Team } from './portal/Team';
import { StaffAccount } from '../components/portal/StaffAccount';
export function PortalApp() {
  const {
    portalRoute,
    goPortal,
    staffUser,
    staffSignOut
  } = usePortal();
  const [accountOpen, setAccountOpen] = useState(false);
  const [creating, setCreating] = useState(false);
  return <div className="min-h-screen w-full bg-ink text-paper" data-id="element-830" data-mp="36q0st439zwz3">
      <header className="border-b border-ruleDark" data-id="element-831" data-mp="36phlehb94qzb">
        <div className="mx-auto flex max-w-portal items-center justify-between gap-8 px-6 py-6 sm:px-10" data-id="element-832" data-mp="3bou8n361c02f">
          <div className="flex items-center gap-3.5" data-id="element-833" data-mp="38sbqmgdh15f">
            <img src={brand.mark} alt="" className="h-7 w-7 brightness-0 invert" data-id="element-834" data-mp="377id05sno95" />
            <p className="label m-0 text-paper" data-id="element-835" data-mp="81lfp840o5gg">
              Portal Productions
              <span className="label-sm mt-2 block text-paper/35" data-id="element-836" data-mp="3k4hz2dr0pyzw">Studio Admin</span>
            </p>
          </div>

          <div className="flex items-center gap-8" data-id="element-837" data-mp="3f5x1yn72bvfo">
            <button type="button" onClick={() => {
            goPortal('projects');
            setCreating(true);
          }} className="label inline-flex items-center gap-3 border border-paper/30 px-4 py-2.5 text-paper/70 transition-colors duration-150 ease-out hover:border-paper hover:text-paper" data-id="element-838" data-mp="3ttruo3l2lzsr">
              <PlusIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-839" data-mp="1rtnxr3jb79u" />
              New Project
            </button>
            {/* Owners only. The Edge Function re-checks the role server-side. */}
            {staffUser?.role === 'owner' && <button type="button" onClick={() => goPortal('team')} className="label text-paper/50 transition-colors duration-150 ease-out hover:text-paper" data-id="element-840" data-mp="2idbda4pyh939">
                Team
              </button>}
            {/* Whoever is signed in — never a fixed name or address. */}
            <p className="label m-0 hidden text-paper/35 sm:block" data-id="element-841" data-mp="376k9wd7a0fr1">
              {staffUser?.name ?? 'Portal Staff'}
              <span className="label-sm mt-2 block text-paper/25" data-id="element-842" data-mp="3h2nahemhc6bv">{staffUser?.email}</span>
            </p>
            <button type="button" onClick={() => setAccountOpen(open => !open)} className="label text-paper/50 transition-colors duration-150 ease-out hover:text-paper" data-id="element-843" data-mp="3m29qfvtp00od">
              Account
            </button>
            <button type="button" onClick={staffSignOut} className="label border border-paper/30 px-4 py-2.5 text-paper/70 transition-colors duration-150 ease-out hover:border-paper hover:bg-paper hover:text-ink" data-id="element-844" data-mp="3uweigikkbi5h">
              Sign Out
            </button>
          </div>
        </div>
      </header>

      {accountOpen && <StaffAccount onClose={() => setAccountOpen(false)} data-id="element-845" data-mp="1y5trs3of7lzh" />}

      <main className="mx-auto max-w-portal px-6 pb-32 pt-12 sm:px-10 sm:pt-14" data-id="element-846" data-mp="1t4mhnxyt2apn">
        {portalRoute === 'projects' && <Projects creating={creating} setCreating={setCreating} data-id="element-847" data-mp="1o59o6udfi5e3" />}
        {portalRoute === 'project' && <ProjectAdmin data-id="element-848" data-mp="1j7rnfr9kewh6" />}
        {portalRoute === 'team' && <Team data-id="element-849" data-mp="1j9cgfcg8e7cx" />}
      </main>
    </div>;
}